import {cn} from '@lib/utils';

/** Знак Colver (оригинальный логотип продукта) — для оформления `colver`. */
export const ColverLogo = ({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <img
    src='/colver/logo.png'
    alt='Colver'
    width={size}
    height={size}
    className={cn('shrink-0', className)}
  />
);
